import { IVec2 } from "@base/math/Vec2";

export interface IAABB2 {
  minX: number;
  minY: number;
  maxX: number;
  maxY: number;
}

export class AABB2 {
  public static create(): IAABB2 {
    return {
      minX: Number.NaN,
      maxX: Number.NaN,
      minY: Number.NaN,
      maxY: Number.NaN,
    }
  }

  public static growArgs(aabb: IAABB2, x: number, y: number): void {
    if (AABB2.isEmpty(aabb)) {
      aabb.minX = x;
      aabb.minY = y;
      aabb.maxX = x;
      aabb.maxY = y;
    } else {
      aabb.minX = x < aabb.minX ? x : aabb.minX;
      aabb.maxX = x > aabb.maxX ? x : aabb.maxX;
      aabb.minY = y < aabb.minY ? y : aabb.minY;
      aabb.maxY = y > aabb.maxY ? y : aabb.maxY;
    }
  }

  public static growVec2(aabb: IAABB2, p: IVec2): void {
    AABB2.growArgs(aabb, p.x, p.y);
  }

  public static growVec2s(aabb: IAABB2, pts: IVec2[]): void {
    for (const p of pts)
      AABB2.growVec2(aabb, p);
  }

  public static isEmpty(aabb: IAABB2): boolean {
    return isNaN(aabb.minX);
  }

  public static getWidth(aabb: IAABB2): number {
    return aabb.maxX - aabb.minX;
  }

  public static getHeight(aabb: IAABB2): number {
    return aabb.maxY - aabb.minY;
  }

  public static getCenter(aabb: IAABB2): IVec2 {
    return {
      x: (aabb.maxX + aabb.minX) * 0.5,
      y: (aabb.maxY + aabb.minY) * 0.5,
    }
  }

  // public minX: number = Number.NaN;
  // public minY: number = Number.NaN;
  // public maxX: number = Number.NaN;
  // public maxY: number = Number.NaN;

  // public reset(): void {
  //   this.minX = Number.NaN;
  //   this.minY = Number.NaN;
  //   this.maxX = Number.NaN;
  //   this.maxY = Number.NaN;
  // }

  // public get width(): number {
  //   return this.maxX - this.minX;
  // }
  // public get height(): number {
  //   return this.maxY - this.minY;
  // }

  // public get min(): IVec2 {
  //   return Vec2.from(this.minX, this.minY);
  // }

  // public get max(): IVec2 {
  //   return Vec2.from(this.maxX, this.maxY);
  // }

  // public get center(): IVec2 {
  //   return Vec2.from((this.minX + this.maxX) * 0.5, (this.minY + this.maxY) * 0.5);
  // }
}
